const settings = {
	selector: ".lightbox-overlay",
};

const Lightbox = {
	selector: settings.selector,

	init() {
		//onsole.log("Lightbox: Initializing...");
		// Updated selector to find video links based on your HTML structure
		const lightboxLinks = document.querySelectorAll(".lightbox, .video-parent a, a.video-button");
		const lightboxOverlay = document.querySelector(".lightbox-overlay");
		const closeBtn = document.querySelector(".lightbox-overlay__close");

		if (!lightboxOverlay || !closeBtn) {
			console.error("Lightbox: Overlay or close button not found. Aborting.");
			return;
		}
		//console.log(`Lightbox: Found ${lightboxLinks.length} potential lightbox links.`);

		const getYoutubeId = (url) => {
			if (!url) return null;
			const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
			const match = url.match(youtubeRegex);
			return match ? match[1] : null;
		};

		lightboxLinks.forEach((link) => {
			link.addEventListener("click", (e) => {
				e.preventDefault();
				//console.log("Lightbox: Link clicked.", link);

				let type = link.dataset.type;
				let id = link.dataset.id;
				const href = link.getAttribute("href");

				if (!href) {
					return;
				}

				// Determine type from href if not specified in data-type
				if (!type) {
					if (href.includes("youtu.be") || href.includes("youtube.com")) {
						type = "youtube";
					}
				}

				// Extract ID from href if not specified in data-id
				if (!id) {
					if (type === "youtube") {
						id = getYoutubeId(href);
					}
				}

				if (type && id) {
					openLightbox(type, id);
				}
			});
		});

		closeBtn.addEventListener("click", function () {
			closeLightbox();
		});

		// ESC key closes the lightbox
		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape" || e.key === "Esc") {
				closeLightbox();
			}
		});

		lightboxOverlay.addEventListener("click", function (e) {
			if (e.target === lightboxOverlay) {
				closeLightbox();
			}
		});

		function openLightbox(type, id) {
			//console.log(`Lightbox: Opening for type "${type}" with ID "${id}".`);
			const iframeContainer = document.querySelector(".lightbox-overlay__container");
			// Reset classes to handle switching between different lightbox types
			iframeContainer.className = "lightbox-overlay__container";
			iframeContainer.classList.add(type);

		if (type === "youtube") {
			iframeContainer.innerHTML = `<iframe width="560" height="315" src="https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
		} else if (type === "custom") {
				// Get custom HTML from existing DOM element by ID
				const customContent = document.querySelector(`#${id}`);
				if (customContent) {
					iframeContainer.innerHTML = customContent.innerHTML;
				} else {
					iframeContainer.innerHTML = `<p>Custom content not found for ID: ${id}</p>`;
				}
			}

			lightboxOverlay.classList.add("is-visible");
			document.body.classList.add("lightbox-open");
		}

		function closeLightbox() {
			if (!lightboxOverlay.classList.contains("is-visible")) {
				return; // Do nothing if the lightbox is already closed
			}
			//console.log("Lightbox: Closing.");
			const iframeContainer = document.querySelector(".lightbox-overlay__container");
			lightboxOverlay.classList.remove("is-visible");
			// Clear the iframe after the transition to prevent video sound from lingering
			setTimeout(() => (iframeContainer.innerHTML = ""), 300); // 300ms matches CSS transition
			document.body.classList.remove("lightbox-open");
		}
	},
};

export default Lightbox;
